// HubSpot forms that the site's own (Webflow-styled) forms submit to, through HubSpot's
// public Forms API. No API key is involved: the endpoint only accepts submissions to
// published forms in this portal.
// https://developers.hubspot.com/docs/api/marketing/forms (v3 "submit data to a form")

export const HUBSPOT_PORTAL_ID = '45237820';

export interface HubspotForm {
  /** The form's ID, from its URL in HubSpot. */
  formId: string;
  /** Maps each input's `name` on the page to the HubSpot contact property it fills. */
  fields: Record<string, string>;
}

/** "React Website Contact Form": the form on /contact. */
export const contactForm: HubspotForm = {
  formId: 'eeec59d8-ee64-413c-b609-aad68246828d',
  fields: {
    'First-name': 'firstname',
    'Last-name': 'lastname',
    Company: 'company',
    Email: 'email',
    Message: 'message',
  },
};

function cookie(name: string): string | undefined {
  return document.cookie
    .split('; ')
    .find((c) => c.startsWith(`${name}=`))
    ?.slice(name.length + 1);
}

/** Submits a form's values to HubSpot. Throws if HubSpot rejects the submission. */
export async function submitToHubspot(form: HubspotForm, data: FormData): Promise<void> {
  const fields = Object.entries(form.fields).map(([input, property]) => ({
    objectTypeId: '0-1', // contact
    name: property,
    value: String(data.get(input) ?? ''),
  }));
  // hubspotutk is only set once a visitor has accepted HubSpot's tracking cookie. When it
  // is, sending it links the submission to that visitor's page views in HubSpot.
  const hutk = cookie('hubspotutk');
  const res = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_PORTAL_ID}/${form.formId}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        fields,
        context: { pageUri: window.location.href, pageName: document.title, ...(hutk && { hutk }) },
      }),
    },
  );
  if (!res.ok) throw new Error(`HubSpot rejected the submission (HTTP ${res.status}): ${await res.text()}`);
}
